import { useAuthenticatedApiClient } from '@guiker/react-framework'
import { AuthenticatedApiClient } from '@guiker/tenant-application-shared'

export const useTenantApplicationApiClient = useAuthenticatedApiClient(AuthenticatedApiClient)
